import UserIcon from "@mui/icons-material/Person";
import { AccountServicePath, CANDIDATE_USERS, CANDIDATE_ROLE } from "utils/constants";
import ListUsers from "./List";
import EditUsers from "./Edit";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <UserIcon />,
  name: AccountServicePath + CANDIDATE_USERS,
  title: "Кандидат-студенти",
  list: <ListUsers userRole={CANDIDATE_ROLE} />,
  permission: permissions.canPreviewUsers,
  edit: <EditUsers />,
  editPermission: permissions.canUpdateUsers,
};
